<template>
	<div>
		<AppHeader title="지점 예약" is-modal-menu />

		<AppContent>
			<ReservationApp />
		</AppContent>

		<AppFooter />

		<ReservationAppModal />
	</div>
</template>

<script>
import AppHeader from '@/components/App/AppHeader';
import AppContent from '@/components/App/AppContent';
import AppFooter from '@/components/App/AppFooter';
import ReservationApp from '@/components/ReservationApp/ReservationApp';
import ReservationAppModal from '@/components/ReservationAppModal/ReservationAppModal';

export default {
	components: {
		AppHeader,
		AppContent,
		AppFooter,
		ReservationApp,
		ReservationAppModal,
	},
};
</script>
